import { Activity, Sparkles, Gauge, Columns2 } from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface Feature {
  icon: LucideIcon;
  title: string;
  body: string;
}

const FEATURES: Feature[] = [
  {
    icon: Activity,
    title: "Real-time event detection",
    body: "Earnings beats, guidance changes, M&A, regulatory actions — surfaced the moment they break and ranked by impact on the instruments you're monitoring.",
  },
  {
    icon: Sparkles,
    title: "AI Copilot with citations",
    body: "Ask 'why did $TICKER move?' or 'what's the trade today?' and get a sourced answer in seconds. Every claim links back to its source article.",
  },
  {
    icon: Gauge,
    title: "Sentiment & impact scoring",
    body: "Every story is scored for sentiment (bullish, bearish, neutral) and impact (low, medium, high), so you can filter signal from noise at a glance.",
  },
  {
    icon: Columns2,
    title: "Two instruments side by side",
    body: "Monitor two instruments in parallel — each pane has its own LLM analysis cadence, fresh-news wall, and replayable history. Click to compare side by side.",
  },
];

export function Features() {
  return (
    <section className="container mx-auto px-4 py-16">
      <h2 className="mb-12 text-center text-3xl font-semibold tracking-tight">
        Built for traders who don't wait
      </h2>
      <div className="grid gap-6 sm:grid-cols-2">
        {FEATURES.map(({ icon: Icon, title, body }) => (
          <div
            key={title}
            className="rounded-lg border border-border bg-card p-6"
          >
            <Icon className="mb-3 h-6 w-6 text-primary" aria-hidden="true" />
            <h3 className="mb-2 text-lg font-semibold">{title}</h3>
            <p className="text-sm text-muted-foreground">{body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
